import ServiceRequestServices from '@/services/ServiceRequestServices'

const types = {
  GET_SERVICEREQUEST_LIST: '@servicerequest/GET_SERVICEREQUEST_LIST',
  GET_SERVICEREQUEST_TOTAL_CHART_DATA: '@servicerequest/GET_SERVICEREQUEST_TOTAL_CHART_DATA',
  GET_SERVICEREQUEST_TOPFIVE_CHART_DATA: '@servicerequest/GET_SERVICEREQUEST_TOPFIVE_CHART_DATA',
  GET_SERVICEREQUEST: '@servicerequest/GET_SERVICEREQUEST',
  GET_SERVICEREQUEST_STATUS_COMBO: '@servicerequest/GET_SERVICEREQUEST_STATUS_COMBO'
}

export {
  types as serviceRequestTypes
}

export default {
  namespaced: true,
  state: {
    serviceRequestList: [],
    serviceRequestTotalChartData: {},
    serviceRequestTopFiveChartData: {},
    serviceRequest: {},
    serviceRequestStatusCombo: [],
    pagingDTO : {
      pageNo : 0,
      size : 20,
      startIndex : 0,
      totalCount : 0
    }
  },

  getters: {
    serviceRequestList: (state) => state.serviceRequestList,
    pagingDTO: (state) => state.pagingDTO,
    serviceRequestTotalChartData: (state) => state.serviceRequestTotalChartData,
    serviceRequestTopFiveChartData: (state) => state.serviceRequestTopFiveChartData,
    serviceRequest: (state) => state.serviceRequest,
    serviceRequestStatusCombo: (state) => state.serviceRequestStatusCombo
  },

  mutations: {
    [types.GET_SERVICEREQUEST_LIST]: (state, payload) => {
      state.serviceRequestList = payload.serviceRequestList
    },    
    [types.GET_SERVICEREQUEST_TOTAL_CHART_DATA]: (state, payload) => {
      state.serviceRequestTotalChartData = payload.serviceRequestTotalChartData
    },
    [types.GET_SERVICEREQUEST_TOPFIVE_CHART_DATA]: (state, payload) => {
      state.serviceRequestTopFiveChartData = payload.serviceRequestTopFiveChartData
    },
    [types.GET_SERVICEREQUEST]: (state, payload) => {
      state.serviceRequest = payload.serviceRequest
    },
    [types.GET_SERVICEREQUEST_STATUS_COMBO]: (state, payload) => {
      state.serviceRequestStatusCombo = payload.serviceRequestStatusCombo
    }
  },

  actions: {
    async getServiceRequestList ({ commit }, payload) {
      
      commit (types.GET_SERVICEREQUEST_LIST, {
        serviceRequestList: []
      })
      try {
        const response = await ServiceRequestServices.getServiceRequests(payload)
        commit (types.GET_SERVICEREQUEST_LIST, {
          serviceRequestList: response.data.resultData.map((item, index) => {
            return {
              no: index + 1,
              ...item
            }
          })
        })
      } catch (e) {
        commit (types.GET_SERVICEREQUEST_LIST, {
          serviceRequestList: []
        })
      }
      return null
    },
    async getServiceRequestTotalChartData ({ commit }, payload) {
      commit (types.GET_SERVICEREQUEST_TOTAL_CHART_DATA, {
        serviceRequestTotalChartData: {}
      })
      try {
        const response = await ServiceRequestServices.getServiceRequestTotalChartData(payload)
        commit (types.GET_SERVICEREQUEST_TOTAL_CHART_DATA, {
          serviceRequestTotalChartData: response.data.resultData
        })
      } catch (e) {
        commit (types.GET_SERVICEREQUEST_TOTAL_CHART_DATA, {
          serviceRequestTotalChartData: {}
        })
      }
      return null
    },
    async getServiceRequestTopFiveChartData ({ commit }, payload) {
      commit (types.GET_SERVICEREQUEST_TOPFIVE_CHART_DATA, {
        serviceRequestTopFiveChartData: {}
      })
      try {
        const response = await ServiceRequestServices.getServiceRequestTopFiveChartData(payload)
        commit (types.GET_SERVICEREQUEST_TOPFIVE_CHART_DATA, {
          serviceRequestTopFiveChartData: response.data.resultData
        })
      } catch (e) {
        commit (types.GET_SERVICEREQUEST_TOPFIVE_CHART_DATA, {
          serviceRequestTopFiveChartData: {}
        })
      }
      return null
    },
    async getServiceRequest ({ commit }, payload) {
      commit (types.GET_SERVICEREQUEST, {
        serviceRequest: {}
      })
      try {
        const response = await ServiceRequestServices.getServiceRequest(payload)
        commit (types.GET_SERVICEREQUEST, {
          serviceRequest: response.data.resultData
        })
      } catch (e) {
        commit (types.GET_SERVICEREQUEST, {
          serviceRequest: {}
        })
      }
      return null
    },
    async getServiceRequestStatusCombo ({ commit }) {
      commit (types.GET_SERVICEREQUEST_STATUS_COMBO, {
        serviceRequestStatusCombo: []
      })
      try {
        const response = await ServiceRequestServices.getServiceRequestStatusCombo()
        const rs = response.data.resultData
        rs.unshift({value: 'all', name: '', style: ''})
        rs.forEach(status => {
          status.count =0
          switch (status.value){
            case 'open':
              status.style = '-bg-red-1'
              status.cellStyle='-tag red-'
              break
            case  'solved':
              status.style = '-bg-green-1'
              status.cellStyle='-tag green-'
              break
            case  'closed':
              status.style = '-bg-gray-1'
              status.cellStyle='-tag gray-'
              break
            default:
              status.style = '-bg-yellow-1'
              status.cellStyle='-tag yellow-'
          }
          
        });
        commit (types.GET_SERVICEREQUEST_STATUS_COMBO, {
          serviceRequestStatusCombo: rs
        })
        return rs;
      } catch (e) {
        
        commit (types.GET_SERVICEREQUEST_STATUS_COMBO, {
          serviceRequestStatusCombo: []
        })
        return [];
      }
      
    },
    
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/servicerequest.js